import React from 'react';
import { type TFunction } from 'i18next';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectUser } from 'app/store/userSlice';

export default function useSettings(module?: string) {
	const { t } = useTranslation();
	const user = useSelector(selectUser);

	let settings: any = undefined;
	let sysSettings: any = undefined;

	if (user.app) {
		// Fetch module settings from Redux store
		if (module) {
			settings = user.app.modules?.find(x => x.modu_title === module);
			if (!settings) throw new Error("The requested module doesn't exists.");
			if (settings.modu_disabled === 1) throw new Error('The requested module is disabled.');
		}

		// Fetch sysSettings from Redux store
		sysSettings = user.app.sysSettings;
	}

	const translator = React.useCallback((value: string, options?) => t(value?.toUpperCase(), options), [t]);

	return {
		settings,
		sysSettings,
		t: translator as TFunction
	};
}
